import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../redux/hooks";
import { fetchBlogs } from "../redux/Slice";
import Style from "../style/article.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { getBlogsFromDB, saveBlogsToDB } from "../indexDb/blogDb";

const Article = React.memo(() => {
  const dispatch = useAppDispatch();
  const [blogs, setBlogs] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const baseUrl = "https://backend.onedialusa.com/assets/img/blogs/";
  const defaultImage =
    "https://images.unsplash.com/photo-1499750310107-5fef28a66643?fm=jpg&q=60&w=1000";

  useEffect(() => {
    const loadBlogs = async () => {
      setIsLoading(true);
      try {
        // Always load cached data immediately
        const cachedBlogs = await getBlogsFromDB();
        setBlogs(cachedBlogs);
        setIsLoading(false);

        // Fetch from API only on first session
        const hasFetched = sessionStorage.getItem("hasFetchedBlogs");
        if (!hasFetched) {
          const res = await dispatch(fetchBlogs({ page: 1 }));
          if (fetchBlogs.fulfilled.match(res)) {
            const fetchedBlogs = res.payload?.blogs?.blogs?.data || [];

            const isDifferent =
              JSON.stringify(fetchedBlogs) !== JSON.stringify(cachedBlogs);

            if (isDifferent) {
              setBlogs(fetchedBlogs);
              await saveBlogsToDB(fetchedBlogs);
            }
          } else {
            console.error("Failed to fetch blogs", res.error);
          }
          sessionStorage.setItem("hasFetchedBlogs", "true");
        }
      } catch (error) {
        console.error("Failed to load blogs:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadBlogs();
  }, [dispatch]);

  return (
    <div className={Style.container}>
      <div className={Style.wrapper}>
        <div className={Style.title}>
          <h2>Read our latest blogs to Related Articles</h2>
          <a href="/blog">Explore All Blog</a>
        </div>

        <div className={Style.Article}>
          {isLoading ? (
            <div className={Style.loadingWrapper}>
              {[...Array(3)].map((_, i) => (
                <div className={Style.skeletonCard} key={i}>
                  <div className={Style.skeletonImage}></div>
                  <div className={Style.skeletonTitle}></div>
                  <div className={Style.skeletonText}></div>
                </div>
              ))}
            </div>
          ) : (
            <Swiper
              modules={[Autoplay]}
              spaceBetween={10}
              slidesPerView={1}
              loop
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              breakpoints={{
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
            >
              {blogs.map((item) => (
                <SwiperSlide key={item.id}>
                  <a href={`/blog/${item.slug}/${item.id}`}>
                    <div className={Style.ArticleData}>
                      <img
                        src={
                          item.image?.includes("http")
                            ? `${item.image}?w=600&auto=compress&format=webp`
                            : `${baseUrl}${item.image}?w=600&auto=compress&format=webp`
                        }
                        alt={item.title}
                        width="100%"
                        height="250"
                        style={{
                          width: "100%",
                          height: "250px",
                          objectFit: "cover",
                          display: "block",
                        }}
                        loading="lazy"
                        onError={(e) => {
                          (e.target as HTMLImageElement).src = defaultImage;
                        }}
                      />
                      <div className={Style.ArticleText}>
                        <h2>{item.title}</h2>
                        <div
                          className={Style.text}
                          style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            fontSize: "14px",
                            color: "#000",
                            fontWeight: 400,
                          }}
                          dangerouslySetInnerHTML={{ __html: item.content }}
                        />
                        <span>Read More</span>
                      </div>
                    </div>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </div>
    </div>
  );
});

export default Article;
